<template>
    <svg
        id="icon_frontpage"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="30"
        height="30"
        viewBox="0 0 30 30"
    >
        <defs>
            <linearGradient
                id="linear-gradient"
                x1="0.5"
                x2="0.5"
                y2="1"
                gradientUnits="objectBoundingBox"
            >
                <stop offset="0" stop-color="#fff" />
                <stop offset="1" stop-color="#e2bbff" />
            </linearGradient>
        </defs>
        <path
            id="Path_460"
            data-name="Path 460"
            d="M25.144,77.992a2.222,2.222,0,0,1,.657,1.465,1.753,1.753,0,0,1-.478,1.332,1.693,1.693,0,0,1-1.315.533,1.767,1.767,0,0,1-1.2-.466q-.149-.133-.911-.932L20.08,78.009q-1.061-1.115-2.271-2.4T15.524,73.2q-1.076-1.132-1.852-1.964T12.686,70.2a2.583,2.583,0,0,0-1.882-.932,2.75,2.75,0,0,0-1.823.932q-.3.3-1.12,1.149t-1.9,1.981Q4.888,74.463,3.692,75.7t-2.211,2.3Q.466,79.058-.266,79.807t-.881.882a1.86,1.86,0,0,1-1.2.433,1.65,1.65,0,0,1-1.285-.5A1.876,1.876,0,0,1-4.2,79.174a1.975,1.975,0,0,1,.508-1.348q.179-.2,1.105-1.165t2.211-2.3L2.393,71.5q1.479-1.532,2.749-2.863t2.181-2.281q.911-.949,1.061-1.115a3.378,3.378,0,0,1,2.45-1.249,2.891,2.891,0,0,1,2.241.982q.179.166.747.782t1.389,1.5q.822.882,1.837,1.981t2.062,2.214q1.046,1.115,2.047,2.214t1.837,1.981q.837.882,1.4,1.515ZM8.981,73.165a2.6,2.6,0,0,1,1.793-.816,2.391,2.391,0,0,1,1.882.816q.09.1.538.566L14.329,74.9q.657.7,1.479,1.565T17.5,78.192q2,2.064,4.482,4.628v9.274a1.92,1.92,0,0,1-.493,1.3,1.773,1.773,0,0,1-1.33.6H14.508V85.883q0-1.1-.926-1.1H7.875a.743.743,0,0,0-.7.333,1.492,1.492,0,0,0-.194.766q0,.2-.015,1.015t-.015,1.748v5.345H1.482a2.049,2.049,0,0,1-1.374-.433A1.53,1.53,0,0,1-.4,92.327V82.753q2.45-2.5,4.452-4.528.837-.866,1.673-1.715l1.524-1.548q.687-.7,1.15-1.182t.583-.616Z"
            transform="translate(4.197 -63.992)"
            fill="url(#linear-gradient)"
        />
    </svg>
</template>
